import { EXAMPLE_IDS } from './example-ids.js';
import { EXAMPLE_ANSWER_IDS, EXAMPLE_NOW } from './examples.js';
const ids = EXAMPLE_IDS;
const answer = EXAMPLE_ANSWER_IDS;
/**
 * The success skip an example naming a row of `demo@p2c` carried until the template held the layer
 * (CS r6a deliverable 188; retired by hotfix/demo-p2c, DECISIONS 811); no route uses it since.
 */
export const SEEDED_BY_P2C = { skip: 'seeded by demo@p2c (CS r6b)' };
/**
 * `foundry.imports.apply`'s success skip (hotfix/demo-p2c, DECISIONS 811 ruling 1): an apply maps
 * the import's stored file again, read from the data directory, which a database seed does not
 * hold (`demo@p2c` writes its asset rows by hash and size only), as the six file-bound `p2a` skips
 * of DECISIONS 492.
 */
export const APPLY_READS_STORED_FILE = {
    skip: "applying maps the import's stored file again, read from the data directory, which a database seed does not hold",
};
const ability = (score, saveProficient) => ({
    score,
    saveProficient,
    max: null,
    bonuses: { check: '', save: '' },
});
const noTrait = { values: [], bypasses: [], custom: '' };
const noBonus = { attack: '', damage: '' };
const FEAT_ID = '59ce7de4-9735-5153-b943-3bb0c024526f';
/** Tamsin Reed, cut down: one feat, Quayside Stride, with the effect it transfers. */
export const EXAMPLE_CHARACTER = {
    schemaVersion: 1,
    source: { kind: 'foundry', upstreamKey: null, foundryLayout: '5.0-5.2' },
    rules: '2014',
    name: 'Tamsin Reed',
    abilities: {
        str: ability(10, 0),
        dex: ability(17, 1),
        con: ability(13, 0),
        int: ability(12, 1),
        wis: ability(14, 0),
        cha: ability(11, 0),
    },
    skills: [
        { key: 'acr', value: 1, ability: 'dex', bonuses: { check: '', passive: '' }, rollMode: 0 },
        { key: 'ste', value: 2, ability: 'dex', bonuses: { check: '', passive: '' }, rollMode: 0 },
    ],
    tools: [],
    ac: { calc: 'default', flat: null, formula: '' },
    hp: { value: 31, max: 36, temp: 0, tempMax: 0, bonuses: { level: '', overall: '' } },
    initiative: { ability: null, bonus: '' },
    movement: {
        walk: '30',
        burrow: null,
        climb: null,
        fly: null,
        swim: '15',
        units: 'ft',
        hover: false,
        bonus: null,
        special: null,
        ignoredDifficultTerrain: [],
    },
    senses: {
        darkvision: 60,
        blindsight: null,
        tremorsense: null,
        truesight: null,
        units: 'ft',
        special: null,
    },
    spellcastingAbility: null,
    death: { success: 0, failure: 0 },
    exhaustion: 0,
    inspiration: false,
    concentration: { limit: 1 },
    attunement: { max: 3 },
    traits: {
        size: 'med',
        languages: { values: ['common', 'elvish'], custom: ['Harbor Sign'], communication: [] },
        di: noTrait,
        dr: noTrait,
        dv: noTrait,
        ci: { values: [], custom: '' },
        dm: { amounts: [], bypasses: [] },
        weaponProf: { values: ['sim'], custom: '' },
        armorProf: { values: ['lgt'], custom: '' },
    },
    currency: [
        { key: 'gp', amount: 34 },
        { key: 'sp', amount: 12 },
    ],
    resources: [],
    spellSlots: [],
    pactSlots: null,
    bonuses: {
        mwak: noBonus,
        rwak: noBonus,
        msak: noBonus,
        rsak: noBonus,
        abilities: { check: '', save: '', skill: '' },
        spell: { dc: '' },
    },
    details: {
        race: { text: 'Half-elf', itemId: null },
        background: { text: null, itemId: null },
        originalClass: null,
        alignment: 'Chaotic Good',
        xp: 6500,
        trait: '<p>I count exits before I count coins.</p>',
        ideal: '<p>Nobody drowns alone.</p>',
        bond: '<p>The lamplighters raised me.</p>',
        flaw: '<p>I keep what I find.</p>',
        appearance: {
            appearance: '',
            age: '19',
            eyes: 'grey',
            faith: '',
            gender: '',
            hair: 'black',
            height: '',
            skin: '',
            weight: '',
        },
        biography: { value: '', public: '' },
    },
    classes: [],
    items: [
        {
            id: FEAT_ID,
            foundryId: 'featQuaysideSt1a',
            name: 'Quayside Stride',
            type: 'feat',
            sort: 0,
            identifier: 'quayside-stride',
            description: '<p>Years on the wet stones of the Lantern Quay quicken your step.</p>',
            rules: '2014',
            quantity: null,
            weight: null,
            price: null,
            rarity: null,
            equipped: null,
            attunement: null,
            attuned: null,
            containerId: null,
            uses: null,
            weapon: null,
            equipment: null,
            consumable: null,
            tool: null,
            containerStats: null,
            spell: null,
            feat: { type: { value: 'feat', detail: null }, requirements: '', properties: [] },
            activities: [],
            ddbId: '41002',
        },
    ],
    favorites: [],
    specialTraits: [],
    effects: [
        {
            itemFoundryId: 'featQuaysideSt1a',
            effectId: 'effQuaysideStr01',
            name: 'Quayside Stride',
            transfer: true,
            disabled: false,
            changes: [{ key: 'system.attributes.movement.walk', mode: 2, value: '10' }],
        },
    ],
};
const IMPORT_HASH = '5c1f0e3a9b7d2c4e6f8a0b1c3d5e7f9a1b3c5d7e9f0a2b4c6d8e0f1a3b5c7d9e';
/** Tamsin Reed's primary sheet, imported: hit points edited here, the rest Foundry's. */
export const EXAMPLE_CHARACTER_SHEET = {
    id: ids.sheetTamsinReed.id,
    documentId: ids.pcTamsinReed.id,
    label: null,
    isPrimary: true,
    kind: 'character',
    rulesVersion: '2014',
    schemaVersion: 1,
    data: EXAMPLE_CHARACTER,
    derived: null,
    derivedSource: 'macro',
    source: 'foundry',
    fieldOrigins: {
        'abilities.dex.score': 'foundry',
        'hp.max': 'local',
        [`items.${FEAT_ID}`]: 'foundry',
    },
    // Version 1 as applied; 2 once the GM edited its hit points (CS r6b).
    version: 2,
    createdAt: EXAMPLE_NOW,
    updatedAt: EXAMPLE_NOW,
    foundrySnapshot: { attributes: { ac: { value: 13 }, init: { total: 3 } } },
    externalIds: {
        ddb: { characterId: '900000001', url: 'https://www.dndbeyond.com/characters/900000001' },
    },
    foundry: {
        rawAssetId: ids.assetFoundryPartyFile.id,
        systemVersion: '5.2.5',
        coreVersion: '13.348',
        importHash: IMPORT_HASH,
        importedAt: EXAMPLE_NOW,
        modifiedAt: EXAMPLE_NOW,
    },
};
/** The sheet after `sheets.character.update` reverted its hit points to Foundry's. */
export const EXAMPLE_CHARACTER_SHEET_REVERTED = {
    ...EXAMPLE_CHARACTER_SHEET,
    version: 3,
    fieldOrigins: { ...EXAMPLE_CHARACTER_SHEET.fieldOrigins, 'hp.max': 'foundry' },
};
const PARTY_FILE = 'codex-actors-drowned-lanterns-20261007T120000.json';
const noFlags = { modules: [], leafCount: 0 };
/** Tamsin Reed's import of the party file, applied as a new player character. */
export const EXAMPLE_ACTOR_IMPORT_APPLIED = {
    id: ids.actorImportTamsinApplied.id,
    rv: 2,
    assetId: ids.assetFoundryPartyFile.id,
    fileName: PARTY_FILE,
    entry: 0,
    status: 'applied',
    refusal: null,
    actorType: 'character',
    name: 'Tamsin Reed',
    systemVersion: '5.2.5',
    coreVersion: '13.348',
    layout: '5.0-5.2',
    proposedTypeKey: 'pc',
    identity: { outcome: 'new', silent: false, source: null, proposals: [], reasons: [] },
    compendium: null,
    warnings: [],
    moduleFlags: { modules: ['ddbimporter'], leafCount: 2 },
    snapshotPresent: true,
    hasBiography: false,
    sheetId: ids.sheetTamsinReed.id,
    documentId: ids.pcTamsinReed.id,
    identitySource: null,
    batchId: ids.batchTamsinImport.id,
    appliedAt: EXAMPLE_NOW,
    undoneAt: null,
    createdAt: EXAMPLE_NOW,
    updatedAt: EXAMPLE_NOW,
};
/**
 * `foundry.imports.undo` on Brother Hale's import (entry 1 of the party file, applied to his `p1a`
 * page by `demo@p2c`, his sheet unedited since): the row undone. Its page, sheet and batch are
 * `demo@p2c`'s (`demo.pc.hale`, `demo.sheet.brotherHale`, `demo.changeBatch.haleApply`).
 */
export const EXAMPLE_IMPORT_UNDONE = {
    ...EXAMPLE_ACTOR_IMPORT_APPLIED,
    id: ids.actorImportHaleApplied.id,
    rv: 3,
    entry: 1,
    status: 'undone',
    name: 'Brother Hale',
    sheetId: '01a096fd-a380-7000-8000-0000000d0f02',
    documentId: '01a096fd-a380-7000-8000-0000000d0101',
    batchId: '01a096fd-a380-7000-8000-0000000d1621',
    undoneAt: EXAMPLE_NOW,
};
/** The Drowned Acolyte of the same file, previewed: an NPC, new, a stat block to be. */
export const EXAMPLE_ACTOR_IMPORT_PREVIEWED = {
    ...EXAMPLE_ACTOR_IMPORT_APPLIED,
    id: ids.actorImportAcolytePreviewed.id,
    rv: 1,
    entry: 4,
    status: 'previewed',
    actorType: 'npc',
    name: 'Drowned Acolyte',
    proposedTypeKey: 'creature',
    moduleFlags: noFlags,
    warnings: [{ code: 'description_sanitized', path: 'items[1].system.description.value' }],
    sheetId: null,
    documentId: null,
    batchId: null,
    appliedAt: null,
};
/** `foundry.imports.get` on the preview: its report, no diff (nothing to refresh), no biography. */
export const EXAMPLE_ACTOR_IMPORT_DETAIL = {
    ...EXAMPLE_ACTOR_IMPORT_PREVIEWED,
    mappingReport: {
        mapper: 'dnd5e@5.0-5.2',
        mapperVersion: 1,
        unmappedPaths: [],
        counts: { items: 3, activities: 3, effects: 0, transferredEffects: 0 },
    },
    diff: null,
    biography: null,
};
/** The upload of Kett's Export Data file. */
export const EXAMPLE_FOUNDRY_FILE = {
    name: 'fvtt-Actor-kett-KettTiefling0001.json',
    type: 'application/json',
    base64: 'eyJfaWQiOiJLZXR0VGllZmxpbmcwMDAxIiwibmFtZSI6IktldHQiLCJ0eXBlIjoiY2hhcmFjdGVyIiwic3lzdGVtIjp7fSwiaXRlbXMiOltdLCJlZmZlY3RzIjpbXSwiX3N0YXRzIjp7InN5c3RlbUlkIjoiZG5kNWUiLCJzeXN0ZW1WZXJzaW9uIjoiNS4yLjUiLCJjb3JlVmVyc2lvbiI6IjEzLjM0OCJ9fQ==',
};
/** `foundry.imports.create`'s answer: the stored file and its one previewed row. */
export const EXAMPLE_FOUNDRY_IMPORT_FILE = {
    assetId: answer.foundryAssetCreated,
    fileName: EXAMPLE_FOUNDRY_FILE.name,
    format: 'export',
    imports: [
        {
            ...EXAMPLE_ACTOR_IMPORT_PREVIEWED,
            id: answer.actorImportCreated,
            assetId: answer.foundryAssetCreated,
            fileName: EXAMPLE_FOUNDRY_FILE.name,
            entry: 0,
            actorType: 'character',
            name: 'Kett',
            proposedTypeKey: 'pc',
            warnings: [],
            snapshotPresent: false,
        },
    ],
};
/** The Acolyte applied onto its creature document as a second sheet, "Foundry" (DECISIONS 220 ruling 51). */
export const EXAMPLE_ACTOR_IMPORT_APPLY = {
    baseRv: 1,
    choices: {
        target: { kind: 'document', documentId: ids.creatureDrownedAcolyte.id, label: 'Foundry' },
    },
};
export const EXAMPLE_ACTOR_IMPORT_APPLY_ANSWER = {
    import: {
        ...EXAMPLE_ACTOR_IMPORT_PREVIEWED,
        rv: 2,
        status: 'applied',
        sheetId: answer.sheetAcolyteFoundry,
        documentId: ids.creatureDrownedAcolyte.id,
        batchId: answer.changeBatch,
        appliedAt: EXAMPLE_NOW,
    },
    documentId: ids.creatureDrownedAcolyte.id,
    sheetId: answer.sheetAcolyteFoundry,
    linkedReferenceId: null,
};
/**
 * A `link` (only when `compendium.unchanged`): an SRD Ghoul from the dnd5e compendium, unchanged,
 * applied as a link to the reference page; no document, sheet or `foundry_map` row is written.
 */
export const EXAMPLE_ACTOR_IMPORT_APPLY_LINK = {
    request: { baseRv: 1, choices: { srdOrigin: 'link' } },
    response: {
        import: {
            ...EXAMPLE_ACTOR_IMPORT_PREVIEWED,
            id: answer.actorImportGhoulLinked,
            rv: 2,
            status: 'applied',
            name: 'Ghoul',
            compendium: {
                uuid: 'Compendium.dnd5e.monsters.Actor.SrdGhoul00000001',
                referenceDocumentId: ids.referenceGhoul.id,
                unchanged: true,
            },
            warnings: [],
            batchId: answer.changeBatch,
            appliedAt: EXAMPLE_NOW,
        },
        documentId: null,
        sheetId: null,
        linkedReferenceId: ids.referenceGhoul.id,
    },
};
/** `foundry.macro.get`: the macro the GM pastes into Foundry. */
export const EXAMPLE_FOUNDRY_MACRO = {
    contentType: 'text/javascript',
    body: '// Codex export macro\n',
};
const importState = (status, reason) => ({
    status: 409,
    body: {
        code: 'foundry_import_state',
        message: 'The import cannot take this step.',
        details: reason === undefined ? { status } : { status, reason },
    },
});
const wrongKind = (kind) => ({
    code: 'wrong_kind',
    message: kind === 'character' ? 'The sheet is a character sheet.' : 'The sheet is a stat block.',
    details: { kind },
});
const tamsin = { id: ids.pcTamsinReed.id, sheetId: ids.sheetTamsinReed.id };
const acolyte = { id: ids.creatureDrownedAcolyte.id, sheetId: ids.sheetDrownedAcolyte.id };
/**
 * The 2c refusals, each 409 the round added (`declared-answers.test.ts`). A request naming a
 * `demo@p2c` row meets its refusal once CS r6b seeds the layer; one with no request has no demo
 * row in the needed status (no rejected preview, no second applied import of a sheet). Apply's
 * 403 `reference_read_only` (DECISIONS 769 ruling 7) is a `sheet` target naming a reference
 * sheet, which the deny pointer (`body.choices.target.documentId`) cannot see: 2.I s3 answers it
 * in the handler, not the route's guard.
 */
export const EXAMPLE_2C_REFUSALS = {
    'sheets.get': [
        { status: 409, body: wrongKind('character'), request: { params: { sheetId: tamsin.sheetId } } },
    ],
    'sheets.update': [
        {
            status: 409,
            body: wrongKind('character'),
            request: { params: tamsin, body: { baseVersion: 2, label: 'Foundry' } },
        },
    ],
    'sheets.character.get': [
        {
            status: 409,
            body: wrongKind('statblock'),
            request: { params: { sheetId: acolyte.sheetId } },
        },
    ],
    'sheets.character.update': [
        {
            status: 409,
            body: wrongKind('statblock'),
            request: { params: acolyte, body: { baseVersion: 1, revertPaths: ['hp.max'] } },
        },
        {
            status: 409,
            body: {
                code: 'row_conflict',
                message: 'The sheet changed since it was read.',
                // `rv`, as `errors.ts`'s row_conflict and sheets.update answer it (DECISIONS 805.2).
                details: { current: { rv: 2 } },
            },
            request: { params: tamsin, body: { baseVersion: 7, revertPaths: ['hp.max'] } },
        },
        // CS r6b (DECISIONS 802.3): no demo page with a character sheet is in the trash.
        {
            status: 409,
            body: { code: 'document_trashed', message: 'The document is in the trash.' },
        },
    ],
    'foundry.imports.reject': [
        {
            ...importState('applied'),
            request: {
                params: { importId: ids.actorImportTamsinApplied.id },
                body: { baseRv: 2 },
            },
        },
    ],
    'foundry.imports.apply': [
        importState('rejected'),
        {
            status: 403,
            body: { code: 'reference_read_only', message: 'Reference documents are read-only.' },
            request: {
                params: { importId: ids.actorImportAcolytePreviewed.id },
                body: {
                    baseRv: 1,
                    choices: {
                        target: { kind: 'sheet', sheetId: ids.sheetReferenceGhoul.id, baseVersion: 1 },
                    },
                },
            },
        },
    ],
    'foundry.imports.undo': [
        importState('applied', 'not_newest'),
        importState('applied', 'changed_since'),
    ],
};
//# sourceMappingURL=examples-foundry.js.map